<template>
  <div class="edit-style-select-button">
    <div
      class="common-buttons-box"
    >
      <button
        type="button"
        v-for="option in options"
        :key="option.text"
        :class="{'active': selected(option.value)}"
        @click="updateStyles(option.value)"
        :disabled="disabled"
      >
        <!-- vertical-align の場合のみ、アイコン画像表示 -->
        <template v-if="target == 'vertical-align'">
          <!-- 選択済と未選択で、使用する画像を切り替える -->
          <template v-if="selected(option.value)">
            <img :src="option.selected">
          </template>
          <template v-else>
            <img :src="option.text">
          </template>
        </template>
        <!-- vertical-align 以外：アイコンフォントで表示 -->
        <template v-else>
          <i class="fas" :class="option.text"></i>
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import EditStyleSelectBase from '@/components/Content/Palette/CommonLayouts/Base/EditStyleSelectBase'

export default {
  props: [
    'target',
    'value',
    'disabled',
  ],
  mixins: [
    EditStyleSelectBase,
  ],
  data () {
    return {
      options: [],
    }
  },
  computed: {
    selected: function () {
      return function (option) {
        return option === this.value
      }
    }
  },
  methods: {
    updateStyles (value) {
      this.$emit('updateStyles', [
        { prop: this.target, value: value }
      ])
    }
  },
  beforeMount () {
    this.options = this.initOptions(this.target)
  },
  mounted () {
    this.labelText = this.initLabelText(this.target)
  },
}
</script>

<style lang="scss">
  .common-buttons-box {
    > button {
      &:disabled {
        background-color: #bebdbd;
        color: #484848;
      }
    }
  }
</style>
